<template>
  <div class="ims-race-selector">
    <!-- Selected Menu Item -->
    <ims-item
      class="ims-row selected no-border"
      @click="toggle"
    >
      <template v-slot:left>
        <div
          class="race-logo"
          v-if="race"
          :style="`background-image:url(${race.logoUrl});`"
        ></div>
        <ims-spinner
          :size="12"
          v-if="!races.length"
        />
      </template>

      <!-- The Active Race -->
      <div
        v-if="race"
        class="py-2"
      >
        <h1 class="race-name">{{ race.name }}</h1>
        <p v-if="race.status == $AppConfig.status.OPEN">
          {{
            (race || {}).greenFlagDateTime | dateFormat('ddd MM/DD/YYYY h:mm A')
          }}
        </p>
        <!-- Active Race Status -->
        <div class="ims-row pt-1">
          <ims-badge
            size="xs"
            v-if="race.status == $AppConfig.status.COMPLETE"
          >FINISHED</ims-badge>
          <ims-badge
            size="xs"
            v-if="
              race.status == $AppConfig.status.PRE_RACE &&
                !racePicksClosed(race)
            "
            color="green"
          >PICK</ims-badge>
          <ims-badge
            size="xs"
            v-else-if="
              race.status == $AppConfig.status.PRE_RACE && racePicksClosed(race)
            "
          >Closed</ims-badge>
          <ims-countdown
            @end="raceStarted()"
            :expires="race.greenFlagDateTime"
            v-if="race.status == $AppConfig.status.PRE_RACE"
          >
            <template v-slot:during>Ends In</template>
            <template v-slot:finished>Picks Closed</template>
          </ims-countdown>
          <ims-badge
            size="xs"
            v-if="race.status == $AppConfig.status.IN_PROGRESS"
            color="red"
          >LIVE</ims-badge>
        </div>
      </div>

      <!-- No Race, but we have races -->
      <div
        v-if="!race && races.length"
        class="py-2"
      >
        <h1>Select a Race to Begin</h1>
        <p>{{ races.length }} race(s) available</p>
      </div>

      <!-- No Race and no Races -->
      <div
        v-if="!race && !races.length"
        class="py-2"
      >
        <h1>No Races available.</h1>
        <p>Please check back soon.</p>
      </div>

      <template v-slot:right>
        <ims-icon
          icon="keyboard_arrow_up"
          v-if="show"
        />
        <ims-icon
          icon="keyboard_arrow_down"
          v-if="!show"
        />
      </template>
    </ims-item>

    <!-- Dropdown Menu -->

    <nav :class="` menu ${show ? 'visible' : 'hidden'}`">
      <ims-item
        :class="
          `p-2 ims-row ${
            race && loopRace.id == race.id ? 'selected' : 'not-selected'
          }
          ${index == races.length - 1 ? 'no-border' : ''}`
        "
        @click="select(loopRace)"
        v-for="(loopRace, index) in races"
        :key="index"
      >
        <template v-slot:left>
          <div
            class="race-logo"
            :style="`background-image:url(${loopRace.logoUrl})`"
          ></div>
        </template>
        <template>
          <h1 class="text-md">{{ loopRace.name }}</h1>
          <p>
            {{
              loopRace.greenFlagDateTime | dateFormat('ddd MM/DD/YYYY h:mm a')
            }}
          </p>
        </template>
        <template v-slot:right>
          <ims-badge
            v-if="
              loopRace.status == $AppConfig.status.PRE_RACE &&
                !racePicksClosed(loopRace)
            "
            size="xs"
            color="green"
          >PICK</ims-badge>
          <ims-badge
            v-else-if="
              loopRace.status == $AppConfig.status.PRE_RACE &&
                racePicksClosed(loopRace)
            "
            size="xs"
            class="py-3"
          >PICKS<br />CLOSED</ims-badge>
          <ims-badge
            v-if="loopRace.status == $AppConfig.status.IN_PROGRESS"
            size="xs"
            color="red"
          >LIVE</ims-badge>
          <ims-badge
            v-if="loopRace.status == $AppConfig.status.COMPLETE"
            size="xs"
          >FINISHED</ims-badge>
        </template>
      </ims-item>
    </nav>
    <!-- end Menu -->
  </div>
</template>

<script>
import tick from '../../modules/tick/tick';
import dayjs from 'dayjs';
export default {
  data() {
    return {
      show: false
    };
  },
  methods: {
    toggle() {
      this.show = !this.show;
      this.$forceUpdate();
    },
    /**
     * Race has Started
     * Triggered by <ims-countdown> this happens when the timer
     * hits the greenFlagDateTime - when this happens
     * the user will be notified, and asked to reload the page.
     * ONLY if this race started at ZERO days from now.
     * This exists since during testing we might have conflicting data
     * for example a PRE_RACE with an old race datetime
     */
    raceStarted() {
      // How many days ago did this race start
      const daysAgo = dayjs(dayjs()).diff(this.race.greenFlagDateTime, 'day');
      // if it's today - then lets popmenu the user and force a refresh.

      if (daysAgo == 0) {
        if (!this.race.picksClosed()) {
          this.$store.dispatch('races/load');
        }
        this.$forceUpdate();
        // this.$store.dispatch('races/load');
      }
    },
    async select(race) {
      this.$store.dispatch('race/select', race);
      // Let the animation breath a bit 200 ms
      await tick(200);
      this.toggle();
    },
    racePicksClosed(thisRace) {
      if (thisRace) {
        return thisRace.picksClosed();
      } else {
        return true;
      }
    }
  },
  computed: {
    races() {
      return this.$store.getters['races/available'] || [];
    },
    race() {
      return this.$store.state.races.race;
    }
  }
};
</script>

<style lang="scss">
@import '../../scss/utils/variables';
.ims-race-selector {
  border-radius: 10px;
  box-shadow: $box-shadow-1;
  overflow: hidden;
  border: solid 1px rgba(0, 0, 0, 0.1);

  .ims-list-item {
    // border-radius: 10px;
  }

  .menu {
    .ims-row.selected {
      background-color: rgba(0, 0, 0, 0.05);
    }
  }

  .menu {
    background-color: #fff;
    transition: all 0.2s ease-in-out;
    &.visible {
      min-height: 10px;
    }
    &.hidden {
      height: 0px;
      overflow: hidden;
      opacity: 0;
      pointer-events: none;
    }
  }
  .race-logo {
    width: 46px;
    height: 46px;
    background-size: contain;
    background-repeat: no-repeat;
    background-position: center;
  }
}
</style>
